module.exports = __webpack_public_path__ + "img/13.efa60b93.jpg";